import { AspectRatio, Box, Heading, Text } from "@vinomofo/components";

import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "../../link";
import { StorefrontImage } from "../../../types";
import styled from "styled-components";
import { trackEvent } from "../../../utils/track-event";

export interface ArticleTileProps {
  id: string;
  title: string;
  image: StorefrontImage;
  link: string;
  bodyText?: string;
  isLoading?: boolean;
  isFeatured?: boolean;
  tags?: [string];
}

const Container = styled(Box)`
  position: relative;
  color: ${({ theme }) => theme.colors.text.heading};
  transition: color 0.3s ease-in-out;
`;

const TileLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  text-decoration: none;
  font-family: inherit;

  ${Container}:hover & {
    text-decoration: underline;
  }

  ::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;

export const ArticleTile = ({
  id,
  title,
  image,
  link,
  bodyText,
  isLoading = false,
  isFeatured = false,
  tags,
}: ArticleTileProps): JSX.Element => {
  return (
    <Container>
      <Box borderRadius="4px" overflow="hidden" mb={["10px", "15px"]}>
        {isLoading ? (
          <AspectRatio bg="divider" />
        ) : (
          <GatsbyImage
            image={image}
            style={{
              width: "100%",
              height: "100%",
            }}
            alt=""
          />
        )}
      </Box>
      {isLoading ? (
        <Box bg="divider" height={["16px", "20px"]} />
      ) : (
        <Heading
          variant={isFeatured ? "md" : "xxs"}
          color="inherit"
          lineHeight={1.2}
        >
          <TileLink
            to={link}
            isExternal
            onClick={() => {
              trackEvent("Article Clicked", {
                id: id,
                title: title,
                slug: link,
                tags: tags,
                featured: isFeatured,
                type: "Vinomofo Article",
              });
            }}
          >
            {title}
          </TileLink>
        </Heading>
      )}
      {isFeatured && bodyText && (
        <Box mt={["10px", "15px"]}>
          {isLoading ? (
            <Box bg="divider" height={["210px", "144px"]} />
          ) : (
            <Text variant="sm" letterSpacing={0.3} fontSize={1}>
              {bodyText}
            </Text>
          )}
        </Box>
      )}
    </Container>
  );
};
